import { FC, ReactElement } from 'react';
import mixpanelEvents from 'constants/mixpanel';
import { DIGIT_REGEX } from 'constants/regex';
import SvgSpriteLoader from 'destiny/dist/components/molecules/SvgSpriteLoader';
import { ICON_SPRITE_TYPES } from 'destiny/dist/constants/icons';
import { defaultFn } from 'destiny/dist/constants/index';
import { defaultFnType } from 'types';
import { trackMixpanel } from 'utils/mixpanel';
import OtpInput from 'components/otp-input/OtpInput';
import Countdown from 'components/timer/Countdown';

interface OtpInputWithResendProps {
  onChange: (value: string) => void;
  value: string;
  error?: string;
  onSubmit: defaultFnType;
  onResend?: defaultFnType;
  className?: string;
  title?: string;
  subTitle?: string | ReactElement;
  hideMinuteOnZero?: boolean;
  hideResend?: boolean;
}
const OtpInputWithResend: FC<OtpInputWithResendProps> = ({
  onChange = defaultFn,
  value = '',
  error = '',
  onSubmit = defaultFn,
  onResend = defaultFn,
  className = '',
  title = 'Enter authentication Code',
  subTitle = 'Enter OTP sent to your email',
  hideMinuteOnZero = false,
  hideResend = false,
}) => {
  const handleChange: (value: string) => void = (value) => {
    onChange(value);
    trackMixpanel(mixpanelEvents.OTP_CHANGE, { inputLength: value?.trim()?.length });
  };

  return (
    <div className={`tw-flex tw-flex-col tw-gap-2 tw-align-start tw-pb-4 ${className}`}>
      {!!title && <div className='tw-text-TEXT_TERTIARY f-13-500 tw-uppercase tw-mb-2'>{title}</div>}
      {!!subTitle && <div className='f-14-300 tw-mb-2'>{subTitle}</div>}
      <div className={'tw-pb-3'}>
        <OtpInput
          value={value}
          setOtp={handleChange}
          regex={DIGIT_REGEX}
          className={`${error ? 'tw-outline tw-outline-1 tw-outline-ERROR_RED' : 'tw-outline-0'}`}
          onEnter={onSubmit}
          autoFocus
        />
      </div>
      {error && (
        <div className='f-12-300 tw-text-RED_PRIMARY tw-text-left tw-flex'>
          <SvgSpriteLoader
            id='alert-triangle'
            iconCategory={ICON_SPRITE_TYPES.ALERTS_AND_FEEDBACK}
            width={12}
            height={12}
          />
          <span className='tw-ml-2' data-testid='incorrect-otp-error'>
            {error}
          </span>
        </div>
      )}

      {!hideResend && <Countdown callback={onResend} totalTime={45} hideMinuteOnZero={hideMinuteOnZero} />}
    </div>
  );
};

export default OtpInputWithResend;
